import { gql } from '@src/lib/gql'

export const RESPOND_TO_SEAT_APPLICATION = gql`
  mutation RespondToSeatApplication($input: RespondToSeatApplicationInput!) {
    respondToSeatApplication(input: $input) {
      groupCommitment {
        id
        groupCommitmentId
        acceptedAt
        rejectedAt
      }
      advisorEngagement {
        id
        advisorEngagementId
        statusKey
        advisorUserId
        activatedAt
        advisorUser {
          id
          userId
          fullName
          pictureUrl
        }
      }
    }
  }
`
